// Single-purpose status color, surfaced as a small dot on a neutral pill —
// the brand keeps the surface monochrome and lets saturated color carry the
// meaning. Maps to the brand status tokens (armed-ok / warn / alert / live).
const STATUS_DOT: Record<string, string> = {
  pending_local_provision: 'bg-warn-attention',
  pending_local_provision_test: 'bg-warn-attention',
  pending_local_provision_prod: 'bg-warn-attention',
  pending_local_destroy: 'bg-warn-attention',
  pending_local_destroy_hard: 'bg-alert-breach',
  hard_terminated: 'bg-alert-breach',
  provisioning: 'bg-live-sync',
  provisioning_test: 'bg-live-sync',
  provisioning_prod: 'bg-live-sync',
  bootstrapping: 'bg-live-sync',
  deploying: 'bg-live-sync',
  active: 'bg-armed-ok',
  failed: 'bg-alert-breach',
  tearing_down: 'bg-warn-attention',
  torn_down: 'bg-slate-400',
  teardown_failed: 'bg-alert-breach',
};

// Make the underlying state strings nicer to read in the UI.
const LABELS: Record<string, string> = {
  pending_local_provision: 'queued (provision)',
  pending_local_provision_test: 'queued (provision test)',
  pending_local_provision_prod: 'queued (provision prod)',
  pending_local_destroy: 'queued (destroy)',
  pending_local_destroy_hard: 'queued (HARD destroy)',
  hard_terminated: 'hard terminated',
  provisioning_test: 'provisioning test',
  provisioning_prod: 'provisioning prod',
  tearing_down: 'tearing down',
  torn_down: 'torn down',
  teardown_failed: 'teardown failed',
};

export function StatusBadge({ status }: { status: string }) {
  const dot = STATUS_DOT[status] ?? 'bg-slate-400';
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-slate-200 bg-white text-xs font-medium text-ink-800">
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {LABELS[status] ?? status}
    </span>
  );
}
